<template>
  <div>
    <vs-row>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <h2 class="center my-5">
          #EveryLeagueCounts
        </h2>
      </vs-col>
    </vs-row>
    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="8">
        <div class="center my-3">
          The business of basketball requires sophisticated tools for an
          evolving information age. We help brands, fitness organizations, and
          AAU/grassroots tournaments collect and commercialize their data.
        </div>
      </vs-col>
    </vs-row>
    <vs-divider class="my-3" />
    <vs-row>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="4"
        vs-sm="12"
        class="my-5"
      >
        <vx-card style="height: 250px; padding: 10px">
          <div class="my-6">
            <vs-row>
              <vs-col vs-w="1"><feather-icon icon="BriefcaseIcon"/></vs-col>
              <vs-col vs-w="11"><h5>Managed Services</h5></vs-col>
            </vs-row>
            <vs-divider />
            <div>
              We provide table management services for basketball leagues,
              tournaments, showcases, and brand activations. Table management
              includes book, clock(s), & complete stats.
            </div>
          </div>
        </vx-card>
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="4"
        vs-sm="12"
      >
        <vx-card style="height: 250px; padding: 10px">
          <div class="my-6">
            <vs-row>
              <vs-col vs-w="1"><feather-icon icon="SettingsIcon"/></vs-col>
              <vs-col vs-w="11"><h5>Enterprise Software</h5></vs-col>
            </vs-row>
            <vs-divider />
            <div>
              Basketball organizations and institutions require data
              infrastructure. We can help you collect, disseminate, and
              commercialize that data. Professional and amateur federations,
              fitness companies, and corporate recreation enterprises can
              extract full value from their business with our assistance.
            </div>
          </div>
        </vx-card>
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="4"
        vs-sm="12"
      >
        <vx-card style="height: 250px; padding: 10px">
          <div class="my-6">
            <vs-row>
              <vs-col vs-w="1"><feather-icon icon="PieChartIcon"/></vs-col>
              <vs-col vs-w="11"><h5>Subscription Analytics</h5></vs-col>
            </vs-row>
            <vs-divider />
            <div>
              Analytics department in an app for leagues, coaches, and scouts of
              all levels. Go beyond the box score to gain insights about trends
              for your team, as well as opponents.
            </div>
          </div>
        </vx-card>
      </vs-col>
    </vs-row>
    <vs-divider class="my-3" />
    <vs-row vs-justify="center" class="my-5">
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="2"
        vs-sm="6"
      >
        <img
          src="@/assets/images/pages/basketball-rose.png"
          alt="basketball rose"
          class="responsive max-175 rounded-lg"
        />
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="2"
        vs-sm="6"
      >
        <img
          src="@/assets/images/pages/e-basketball-black.png"
          alt="e basketball"
          class="responsive max-175 rounded-lg"
        />
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="2"
        vs-sm="6"
      >
        <img
          src="@/assets/images/pages/hs_nationals_logo.png"
          alt="High School Nationals"
          class="responsive max-175 rounded-lg"
        />
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="2"
        vs-sm="6"
      >
        <img
          src="@/assets/images/pages/made-hoops.png"
          alt="made hoops"
          class="responsive max-175 rounded-lg"
        />
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="2"
        vs-sm="6"
      >
        <img
          src="@/assets/images/pages/nyvsny-logo.png"
          alt="NY vs NY"
          class="responsive max-175 rounded-lg"
        />
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
export default {
  name: "Services",
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
